import { Map as ImmutableMap } from 'immutable';
export const buildCapabilityKey = (capability, capabilityContext) => ImmutableMap(Object.assign({
  capability
}, capabilityContext || {}));